import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as r } from "react";
import { I as a } from "../../../../IconBase-CxZyIWw2.js";
const c = r((e, i) => /* @__PURE__ */ s.jsx(
  a,
  {
    ref: i,
    ...e,
    image: (l) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...l,
        children: [
          /* @__PURE__ */ s.jsxs("g", { clipPath: "url(#clip0_2974_4153)", children: [
            /* @__PURE__ */ s.jsx(
              "mask",
              {
                id: "mask0_2974_4153",
                width: 32,
                height: 32,
                x: 8,
                y: 8,
                maskUnits: "userSpaceOnUse",
                style: {
                  maskType: "alpha"
                },
                children: /* @__PURE__ */ s.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M24 8C15.2 8 8 15.2 8 24s7.2 16 16 16 16-7.2 16-16S32.8 8 24 8m0 1.2c3.8 0 7.3 1.5 9.9 3.9L13.1 33.9c-2.4-2.6-3.9-6.1-3.9-9.9 0-8.1 6.7-14.8 14.8-14.8m0 29.6c-3.8 0-7.3-1.5-10-3.9L34.8 14c2.4 2.6 3.9 6.1 3.9 10 .1 8.1-6.6 14.8-14.7 14.8"
                  }
                )
              }
            ),
            /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_4153)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h48v48H0z" }) })
          ] }),
          /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_2974_4153", children: /* @__PURE__ */ s.jsx("path", { fill: "#fff", d: "M0 0h48v48H0z" }) }) })
        ]
      }
    )
  }
));
c.displayName = "AgencyNoneIcon";
export {
  c as AgencyNoneIcon,
  c as default
};
//# sourceMappingURL=index.js.map
